import { Dispatch } from "redux";
import { LoadingAction, isLoadingAction } from "./action";

export function OpenLoadingBarThunk(isLoading:boolean){
    return (dispatch: Dispatch<LoadingAction>)=>{
      dispatch(isLoadingAction(isLoading));  
  }
}